// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__23Rsh","right":"Footer_right__28aJc","buttons":"Footer_buttons__3Bvjh"};